import { isFunction } from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MultiSelectorContext } from './multi-selector-context';

export const MultiSelectorContextProvider = ({
  children,
  useOptions,
  useSelectedOptions,
  selectedOptionsLimit,
  optionsDisplayLimit,
  onSelectedOptionsUpdate,
  onChange,
  savedAddedSelectedOptionsKeys,
  savedDeletedSelectedOptionsKeys,
}) => {
  const [searchFilter, setSearchFilter] = React.useState('');
  const [isLoadingOptions, isFirstOptionsLoad, isNoOptionsAfterFirstLoad, isMoreOptionsThanLimit, options, optionsLoadError, lastLoadedSearchFilter, triggerLoadOptions] =
    useOptions(searchFilter, optionsDisplayLimit);

  const [isLoadingSelectedOptions, selectedOptions, initialSelectedOptions, selectedOptionsLoadError, setSelectedOptions, isSelectedOptionsLimitReached] =
    useSelectedOptions(selectedOptionsLimit, onChange, savedAddedSelectedOptionsKeys, savedDeletedSelectedOptionsKeys);

  useEffect(() => {
    if (isFunction(onSelectedOptionsUpdate)) {
      onSelectedOptionsUpdate(selectedOptions);
    }
  }, [onSelectedOptionsUpdate, selectedOptions]);

  return (
    <MultiSelectorContext.Provider
      value={{
        isLoadingOptions,
        isFirstOptionsLoad,
        isNoOptionsAfterFirstLoad,
        isMoreOptionsThanLimit,
        triggerLoadOptions,
        options,
        optionsLoadError,
        lastLoadedSearchFilter,
        selectedOptionsLimit,
        optionsDisplayLimit,

        isLoadingSelectedOptions,
        isSelectedOptionsLimitReached,
        selectedOptions,
        initialSelectedOptions,
        selectedOptionsLoadError,
        setSelectedOptions,

        searchFilter,
        setSearchFilter,
      }}
    >
      {children}
    </MultiSelectorContext.Provider>
  );
};

MultiSelectorContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  useOptions: PropTypes.func.isRequired,
  useSelectedOptions: PropTypes.func.isRequired,
  selectedOptionsLimit: PropTypes.number,
  optionsDisplayLimit: PropTypes.number,
  onChange: PropTypes.func,
  onSelectedOptionsUpdate: PropTypes.func,
  savedAddedSelectedOptionsKeys: PropTypes.arrayOf(PropTypes.number),
  savedDeletedSelectedOptionsKeys: PropTypes.arrayOf(PropTypes.number),
};

MultiSelectorContextProvider.defaultProps = {
  children: null,
  selectedOptionsLimit: 25,
  optionsDisplayLimit: 50,
  onChange: null,
  onSelectedOptionsUpdate: null,
  savedAddedSelectedOptionsKeys: [],
  savedDeletedSelectedOptionsKeys: [],
};
